import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import dayjs from "dayjs";
import { OverlayTrigger, Popover, Toast } from "react-bootstrap";
import { Modal, Spin } from "antd";
import AudioPlayer from "../audioPlayer";
import { useCallContext } from "../CallContext";

type Permission = { id: number; name: string };

type Admin = {
  teacher_id: number,
  employee_id: string,
  employee_code: string,
  full_name: string,
  gender_name: string,
  department_name: string,
  qualification: string,
  years_of_experience: null, // or number if present
  date_of_joining: string, // ISO date string
  email: null, // or string if present
  phone_number: null, // or string if present
  is_active: boolean,
  has_ticket: boolean,
  no_of_attempts: number,
  button: string,
  orientation_name: string,
  class_teacher_class_name: string,
  class_teacher_section_name: string,
  branch: number,
  branch_name: string,
  orientation: number,
  class_teacher_of_class: number,
  class_teacher_of_section: number,
  designation_name?: string,
};

type Slot = {
  id: number;
  teacher: number;
  teacher_name: string;
  emp_code: string | null;
  login_status: boolean;
  last_logged_date: string; // ISO string
  no_of_logins: number;
  no_of_homework_given: number;
  no_of_students_to_homeworks: number;
  no_of_student_submitted: number;
  imported_at: string; // ISO string
};


// type Disposition = {
//   student_disposition_id: number;
//   disposition_name: string;
// };

// type TicketType = {
//   ticket_type_id: number;
//   ticket_type: string;
// };

type Category = {
  category_id: number;
  category_name: string;
  is_callback_time?: boolean;
};

type SubCategory = {
  subcategory_id: number;
  subcategory_name: string;
};

type Priority = {
  priority_id: number;
  priority_name: string;
};

interface Ticket {
  category?: number | null;
  subcategory?: number | null;
  priority?: number;
  description?: string;
  ticket_id?: number;
  call_back_time?: string | null;
  new_ticket?: string
}

interface TicketLog {
  service_division: string,
  call_logs: any;
  full_name: string;
  description: string;
  category_name: string;
  subcategory: string;
  // ticket_type_name: string;
  priority: string;
  disposition: string;
  // resolve_notes: string;
  remarks: string;
  call_back_time: string;
  // call_start_time: string;
  updated_by_name: string;
  updated_at: string;
  heading: string;
  ticket_history: any,
}

interface CallLog {
  service_division: string;
  call_history: any;
  agent_name: string;
  call_start_time_: string;
  call_end_time_: string;
  call_duration_hms: string;
  conversation_duration_hms: string;
  caller_status: string;
  destination_status: string;
  call_status: string;
  aws_call_recording_file: string;
  student_name: string;
}

interface ScriptData {
  script_id: number;
  script_name: string;
  script_file: string;
  is_active: boolean;
  script_file_url: string;
  external_url: string;
}

interface ScriptDropdown {
  script_id: number;
  script_name: string;
}

interface Sibiling {
  SCS_Number?: string | null;
  name?: string | null;
  admission_status_name?: string | null;
  branch_name?: string | null;
  orientation_name?: string | null;
  student_class_name?: string | null;
  is_wizklub_paid_last_year?: boolean | null;
  is_wizklub_paid?: boolean | null;

}

interface RelationType {
  id: number;
  name: string;
}

interface Contact {
  id: number;
  student: number;
  relation_type: number;
  relation_type_name: string;
  name: string;
  phone_number: string;
}

interface CallOption {
  id: number;
  student: number;
  label: string;
}

interface serviceDivision {
  id: number;
  name: string;
}

interface ClassOption {
  class_name_id: number;
  name: string;
  label: string;
}

interface OrientationOption {
  orientation_id: number;
  name: string;
  label: string;
}

interface SectionOption {
  section_id: number;
  name: string;
  label: string;
}

const AddOrUpdateEmployeeTicket = () => {
  const routes = all_routes;
  const location = useLocation();
  // const { id, r1 } = location.state || {};
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const r1 = Number(searchParams.get("s1"));
  const work_assign_id = searchParams.get("work_assign_id");
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [callLoading, setCallLoading] = useState(false);
  const [messageLoading, setMessageLoading] = useState(false);
  const [whatsappLoading, setWhatsappLoading] = useState(false);
  const [data, setData] = useState<Admin[]>([]);
  const [ticketData, setTicketData] = useState<Ticket[]>([]);
  const [categoriesData, setCategoriesData] = useState<Category[]>([]);
  const [subCategoryData, setSubCategoryData] = useState<SubCategory[]>([]);
  const [serviceDivisions, setServiceDivisions] = useState<serviceDivision[]>([]);
  const [priorityData, setPriorityData] = useState<Priority[]>([]);
  const [ticketLogs, setTicketLogs] = useState<TicketLog[]>([]);
  const [callLogs, setCallLogs] = useState<CallLog[]>([]);
  const [showCallLogs, setShowCallLogs] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showCallHistory, setShowCallHistory] = useState(false);
  const [showTicketLogs, setShowTicketLogs] = useState(true);
  const [showCallBackTime, setShowCallBackTime] = useState(false);
  const { isCalling, setIsCalling } = useCallContext();
  const callBackTimeRef = useRef<HTMLInputElement>(null);
  const [sdata, setsData] = useState<ScriptData[]>([]);
  const [showCard, setShowCard] = useState(false);
  const [scriptDropdown, setScriptDropdown] = useState<ScriptDropdown[]>([]);
  const [selectedScript, setSelectedScript] = useState("");
  const [pdfSrc, setPdfSrc] = useState("");
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [corelationId, setCorelationId] = useState("");
  const [ticketLogLoading, setTicketLogLoading] = useState(false);
  const [callLogLoading, setCallLogLoading] = useState(false);
  const [serviceDivisionLoading, setServiceDivisionLoading] = useState(false);
  const [ticket_id, setTicketId] = useState<number>();
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const [callDuration, setCallDuration] = useState(0);
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);
  const [isLocked, setIsLocked] = useState<boolean>(true);
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [sibiling, setSibiling] = useState<Sibiling[]>([]);
  const [selectedServiceDivision, setSelectedServiceDivision] = useState<string | null>(null);
  const [selectedServiceDivisionCall, setSelectedServiceDivisionCall] = useState<string>("");
  const [expandedLogs, setExpandedLogs] = useState<Record<string, boolean>>({});
  const [selectedCategory, setSelectedCategory] = useState<Option | null>(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState<Option | null>(
    null
  );
  const [selectedPriority, setSelectedPriority] = useState<Option | null>(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedClass, setSelectedClass] = useState<number | null>(null);
  const [selectedOrientation, setSelectedOrientation] = useState<number | null>(null);
  const [selectedSection, setSelectedSection] = useState<number | null>(null);
  const [manualPhoneNumber, setManualPhoneNumber] = useState("");
  const [relationTypes, setRelationTypes] = useState<RelationType[]>([]);
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [slots, setSlots] = useState<Slot[]>([]);
  const [slotsloading, setSlotsLoading] = useState(false);
  const [formData, setFormData] = useState<Partial<Contact>>({
    relation_type: undefined,
    name: "",
    phone_number: "",
  });
  const [editingId, setEditingId] = useState<number | null>(null);
  const [callOptions, setCallOptions] = useState<CallOption[]>([]);
  const [selectedCallId, setSelectedCallId] = useState<string>("");
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [showPopover, setShowPopover] = useState(false);
  const [classOptions, setclassOptions] = useState<ClassOption[]>([]);
  const [branchOptions, setbranchOptions] = useState<OrientationOption[]>([]);
  const [sectionOptions, setsectionOptions] = useState<SectionOption[]>([]);
  // Popover message for "Save" button if isCalling is true
  const popoverWarning = (
    <Popover id="popover-warning">
      <Popover.Header as="h3">Action Restricted</Popover.Header>
      <Popover.Body>
        The ticket can only be submitted after the call disconnects.
      </Popover.Body>
    </Popover>
  );

  useEffect(() => {
    if (!checkPermission("view_teacherticket", "teacherticket")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData();
      // fetchRelationTypes();
      // fetchContacts();
      fetchServiceDivisions();
      fetchPriorityData();
      // fetchCategoriesData();
      fetchTicketLogs(Number(id));
      fetchClassesDropdown();
      fetchSlotsData()
    }
  }, [userPermissions]);

  useEffect(() => {
    console.log("class", selectedClass);
    console.log("orientation", selectedOrientation);
    console.log("section", selectedSection);
  }, [selectedClass, selectedOrientation, selectedSection])

  useEffect(() => {
    if (selectedClass && selectedOrientation) {
      fetchSectionDropdown();
    }
  }, [selectedOrientation, selectedClass]);


  const handlePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  useEffect(() => {
    if (audioRef.current) {
      const updateCurrentTime = () =>
        setCurrentTime(audioRef.current!.currentTime);
      const updateDuration = () => setDuration(audioRef.current!.duration);

      audioRef.current.addEventListener("timeupdate", updateCurrentTime);
      audioRef.current.addEventListener("loadedmetadata", updateDuration);

      return () => {
        audioRef.current?.removeEventListener("timeupdate", updateCurrentTime);
        audioRef.current?.removeEventListener("loadedmetadata", updateDuration);
      };
    }
  }, []);

  const handleToggleLog = (logKey: string) => {
    setExpandedLogs(prev => ({
      ...prev,
      [logKey]: !prev[logKey]
    }));
  };
  const handleToggleForm = () => {
    setShowForm(true);
    setShowCallLogs(false);
    setShowTicketLogs(false);
    setShowCard(false);
  };

  const handleToggleCallLogs = async () => {
    setShowForm(false);
    setShowCallLogs(true);
    setShowTicketLogs(false);
    setShowCard(false);
    setCallLogLoading(true);
    try {
      const response = await fetch(
        `${webApi}/call/employee_wise_call_logs/${id}/`,
        options
      );
      const data = await response.json();
      setCallLogs(data.results);
    } catch (error) {
      console.error("Error fetching call logs:", error);
    } finally {
      setCallLogLoading(false);
    }
  };

  const handleToggleTicketLogs = async (ticket_id: number) => {
    setShowForm(false);
    setShowCallLogs(false);
    setShowTicketLogs(true);
    setShowCard(false);
    setTicketLogLoading(true);
    try {
      const response = await fetch(
        `${webApi}/employees/get_teacher_ticket_logs_by_teacher/${ticket_id}`,
        options
      );
      const data = await response.json();
      setTicketLogs(data.results);
    } catch (error) {
      console.error("Error fetching ticket logs:", error);
    } finally {
      setTicketLogLoading(false);
    }
  };

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const [newAdmin, setNewAdmin] = useState<Admin>({
    teacher_id: 0,
    employee_id: "",
    employee_code: "",
    full_name: "",
    gender_name: "",
    department_name: "",
    qualification: "",
    years_of_experience: null,
    date_of_joining: "",
    email: null,
    phone_number: null,
    is_active: false,
    has_ticket: false,
    no_of_attempts: 0,
    orientation_name: "",
    class_teacher_class_name: "",
    class_teacher_section_name: "",
    button: "Add Ticket",
    branch: 0,
    branch_name: "",
    orientation: 0,
    class_teacher_of_class: 0,
    class_teacher_of_section: 0,
  });

  const [newTicket, setNewTicket] = useState<Ticket>({
    category: undefined,
    subcategory: null,
    priority: undefined,
    description: "",
    call_back_time: null,
    new_ticket: "True",
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const handleEditClick = async (e: React.MouseEvent) => {
    e.preventDefault();

    try {
      // Step 1: Fetch teacher data
      const response = await fetch(`${webApi}/employees/update_teacher_details/${newAdmin.teacher_id}/`, options);
      const data = await response.json();

      // Step 2: Extract matching class and orientation IDs
      const classObj = classOptions.find(c => c.name === data.class_teacher_class_name);
      const branchObj = branchOptions.find(b => b.name === data.orientation_name);
      const classId = classObj?.class_name_id ?? null;
      const orientationId = branchObj?.orientation_id ?? null;

      // Step 3: Set class and orientation in state
      setSelectedClass(classId);
      setSelectedOrientation(orientationId);

      // Step 4: Directly fetch section options based on the new class and orientation
      if (classId && orientationId && newAdmin.branch) {
        const sectionResponse = await fetch(
          `${webApi}/branches/section_dropdown_based_on_branch_orientation_class/?branch_id=${newAdmin.branch}&class_id=${classId}&orientation_id=${orientationId}`,
          options
        );

        if (sectionResponse.ok) {
          const sectionData = await sectionResponse.json();
          setsectionOptions(sectionData);
          const sectionObj = sectionData.find((s: any) => s.section_id === data.class_teacher_of_section);

          // Set the selected section and THEN open the modal
          setSelectedSection(sectionObj?.section_id ?? null);
          setManualPhoneNumber(data.phone_number);
          setShowModal(true); // Open modal only after section is set
        } else {
          // Handle case where section fetch fails but we still want to open modal
          setSelectedSection(null);
          setManualPhoneNumber(data.phone_number);
          setShowModal(true);
        }
      } else {
        // Handle case where we don't have required IDs but still want to open modal
        setSelectedSection(null);
        setManualPhoneNumber(data.phone_number);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error during handleEditClick:", error);
    }
  };




  const handleSave = async () => {
    // const classObj = classOptions.find(c => c.class_name_id === selectedClass);
    // const branchObj = branchOptions.find(b => b.orientation_id === selectedOrientation);
    // const sectionObj = sectionOptions.find(s => s.section_id === selectedSection);

    const payload = {
      class_teacher_of_class: selectedClass,
      orientation: selectedOrientation,
      class_teacher_of_section: selectedSection,
      phone_number: manualPhoneNumber,
    };

    try {
      const response = await fetch(`${webApi}/employees/update_teacher_details/${newAdmin.teacher_id}/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Failed to update data");
      setShowModal(false);
      fetchData();
    } catch (error) {
      console.error("PUT error:", error);
      alert("Failed to save changes.");
    }
  };

  // const fetchCallOptions = async () => {
  //   try {
  //     const res = await fetch(`${webApi}/students/student_contact_number_dropdown/?student_id=${id}`, options);
  //     const data: CallOption[] = await res.json();
  //     setCallOptions(data);
  //   } catch (error) {
  //     console.error("Error fetching call options:", error);
  //   }
  // };

  // const handleCallButtonClick = () => {
  //   fetchCallOptions();
  // };

  // const openModal = (contact?: Contact) => {
  //   setShowModal(true);
  //   if (contact) {
  //     setEditingId(contact.id);
  //     setFormData({
  //       relation_type: contact.relation_type,
  //       name: contact.name,
  //       phone_number: contact.phone_number,
  //     });
  //   } else {
  //     setEditingId(null);
  //     setFormData({ relation_type: undefined, name: "", phone_number: "" });
  //   }
  // };

  // const handleCustomModelSubmit = async () => {
  //   if (!formData.relation_type || !formData.phone_number) {
  //     setToastMessage("Relation type and phone number are required.");
  //     setShowSolidDangerToast(true);
  //     setTimeout(() => {
  //       setShowSolidDangerToast(false);
  //     }, 3000);
  //     return;
  //   }

  //   const payload = {
  //     relation_type: formData.relation_type,
  //     name: formData.name,
  //     phone_number: formData.phone_number,
  //   };

  //   try {
  //     const url = editingId
  //       ? `${webApi}/students/get_or_update_student_contacts/${editingId}/`
  //       : `${webApi}/students/create_student_contacts/${id}/`;

  //     const method = editingId ? "PUT" : "POST";

  //     const response = await fetch(url, {
  //       method,
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${jwtToken}`,
  //       },
  //       body: JSON.stringify(payload),
  //     });
  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       if (errorData.non_field_errors && errorData.non_field_errors.length > 0) {
  //         setToastMessage(errorData.non_field_errors[0]);
  //         setTimeout(() => {
  //           setShowSolidDangerToast(false);
  //         }, 3000);
  //       } else {
  //         setToastMessage("Failed to save contact. Please try again.");
  //         setTimeout(() => {
  //           setShowSolidDangerToast(false);
  //         }, 3000);
  //       }
  //       setShowSolidDangerToast(true);
  //       return;
  //     }
  //     setShowModal(false);
  //     fetchContacts(); // Refresh contacts
  //   } catch (error) {
  //     console.error("Error saving contact:", error);
  //   }
  // };


  // const fetchRelationTypes = async () => {
  //   try {
  //     const res = await fetch(`${webApi}/students/relationship_type_dropdown/`, options);
  //     const data: RelationType[] = await res.json();
  //     setRelationTypes(data);
  //   } catch (error) {
  //     console.error("Error fetching relation types:", error);
  //   }
  // };

  // const fetchContacts = async () => {
  //   try {
  //     const res = await fetch(`${webApi}/students/student_contacts_list/${id}/`, options);
  //     const data: Contact[] = await res.json();
  //     setContacts(data);
  //   } catch (error) {
  //     console.error("Error fetching contacts:", error);
  //   }
  // };



  const toggleLock = async (): Promise<void> => {
    if (isLocked) {
      // Fetch phone number from the API
      try {
        const response = await fetch(
          `${webApi}/employees/get_teacher_phone_number/?teacher_id=${newAdmin.teacher_id}`,
          options
        );
        const data = await response.json();
        setPhoneNumber(data.mobile_number);
      } catch (error) {
        console.error("Error fetching phone number:", error);
      }
    } else {
      // Hide the phone number
      setPhoneNumber("");
    }
    setIsLocked(!isLocked);
  };

  const fetchProviderData = async (id: string) => {
    const response = await fetch(
      `${webApi}/employees/teacher_card/${id}`,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  const fetchTicketData = async (id: string, serviceDivision: string | null) => {
    setServiceDivisionLoading(true);
    const categoryResponse = await fetchCategoriesData(serviceDivision);
    setCategoriesData(categoryResponse);

    const resetTicketState = () => {
      setNewTicket({
        category: undefined,
        subcategory: null,
        priority: undefined,
        description: "",
        call_back_time: null,
        new_ticket: "True",
      });
      setTicketData([]);
      setSelectedCategory(null);
      setSelectedSubCategory(null);
      setSelectedPriority(null);
    };

    if (!serviceDivision) {
      console.error("Service division is required");
      setServiceDivisionLoading(false);
      return;
    }

    try {
      // Fetch ticket data
      const response = await fetch(
        `${webApi}/employees/teacher_ticket_operations/${id}/${serviceDivision}`,
        options
      );

      if (response.status === 404) {
        resetTicketState();
      }



      const ticketDataResponse = await response.json();
      setTicketData(ticketDataResponse);
      setNewTicket(ticketDataResponse);

      // Fetch categories


      // Set selected category
      const selectedCategory = categoryResponse.find(
        (c: Category) => c.category_id === ticketDataResponse.category
      );
      setSelectedCategory(
        selectedCategory
          ? {
            value: selectedCategory.category_id.toString(),
            label: selectedCategory.category_name,
          }
          : null
      );

      if (selectedCategory) {
        // Fetch and set subcategories
        const subCategoryDataResponse = await fetchSubCategoryData(
          selectedCategory.category_id
        );
        const subCategories = subCategoryDataResponse.map(
          (sc: SubCategory) => ({
            value: sc.subcategory_id.toString(),
            label: sc.subcategory_name,
          })
        );

        const selectedSubCategory = subCategoryDataResponse.find(
          (sc: SubCategory) =>
            sc.subcategory_id === ticketDataResponse.subcategory
        );
        setSelectedSubCategory(
          selectedSubCategory
            ? {
              value: selectedSubCategory.subcategory_id.toString(),
              label: selectedSubCategory.subcategory_name,
            }
            : null
        );
      }

      // Set selected priority
      const selectedPriority = priorityData.find(
        (p: Priority) => p.priority_id === ticketDataResponse.priority
      );
      setSelectedPriority(
        selectedPriority
          ? {
            value: selectedPriority.priority_id.toString(),
            label: selectedPriority.priority_name,
          }
          : null
      );

      // Format callback time
      const apiCallBackTime = ticketDataResponse.call_back_time_local
        ? formatLocalDateTimeString(ticketDataResponse.call_back_time_local)
        : null;

      setNewTicket((prevTicket) => ({
        ...prevTicket,
        call_back_time: apiCallBackTime,
      }));
    } catch (error) {
      console.error("Error fetching ticket data:", error);
      // Handle error state as needed
    }
    finally {
      // Ensure loading is turned off whether successful or not
      setServiceDivisionLoading(false);
    }
  };

  // const fetchDispositionData = async () => {
  //   const response = await fetch(
  //     `${webApi}/summercamp/dispositions_dropdown/`,
  //     options
  //   );
  //   return await response.json();
  // };

  const fetchCategoriesData = async (serviceDivision: string | null) => {

    const response = await fetch(
      `${webApi}/employees/teacher_ticket_category_dropdown/${serviceDivision}`,
      options
    );
    return await response.json();
  }

  const fetchServiceDivisions = async () => {
    const response = await fetch(
      `${webApi}/employees/teacher_service_division_dropdown_based_on_user/`,
      options
    );
    const data = await response.json();
    setServiceDivisions(data);
  };

  const fetchSubCategoryData = async (categoryId: number) => {
    const response = await fetch(
      `${webApi}/employees/teacher_ticket_subcategory_dropdown/${categoryId}/`,
      options
    );
    return await response.json();
  };

  const fetchPriorityData = async () => {
    const response = await fetch(
      `${webApi}/employees/teacher_ticket_priorities_dropdown/`,
      options
    );
    const data = await response.json();
    setPriorityData(data);
  };

  const fetchClassesDropdown = async () => {
    const response = await fetch(
      `${webApi}/branches/branches_class_name_dropdown/`,
      options
    );
    const data = await response.json();
    setclassOptions(data.results);
  };
  const fetchOrientationsDropdown = async (branch: number) => {
    const response = await fetch(
      `${webApi}/branches/branch_wise_orientations/?branch_id=${branch}`,
      options
    );
    const data = await response.json();
    setbranchOptions(data);
  };
  const fetchSectionDropdown = async (): Promise<any[]> => {
    if (!selectedClass || !selectedOrientation) return [];

    try {
      const response = await fetch(
        `${webApi}/branches/section_dropdown_based_on_branch_orientation_class/?branch_id=${newAdmin.branch}&class_id=${selectedClass}&orientation_id=${selectedOrientation}`,
        options
      );

      if (!response.ok) {
        throw new Error("Failed to fetch section options");
      }

      const data = await response.json();
      setsectionOptions(data); // still update UI
      return data; // return fetched data
    } catch (error) {
      console.error("Error fetching section dropdown:", error);
      return [];
    }
  };



  // const fetchTypeOfTicketData = async () => {
  //   const response = await fetch(
  //     `${webApi}/wizklub/type_of_tickets_dropdown/`,
  //     options
  //   );
  //   return await response.json();
  // };

  const fetchTicketLogs = async (ticket_id: number) => {
    const response = await fetch(
      `${webApi}/employees/get_teacher_ticket_logs_by_teacher/${ticket_id}`,
      options
    );
    const data = await response.json();
    setTicketLogs(data.results)
  };

  const fetchCallLog = async (id: string) => {
    const response = await fetch(
      `${webApi}/call/employee_wise_call_logs/${id}`,
      options
    );
    return await response.json();
  };

  const checkCallEnd = async (correlationId: any) => {
    try {
      const response = await fetch(
        `${webApi}/call/is_call_end/?correlation_id=${correlationId}`,
        options
      );
      const data = await response.json();

      if (data.is_call_end) {
        setIsCalling(false);
        await fetch(`${webApi}/user_monitoring/change_agent_status/1/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({}), // Empty JSON object (not a string)
        });
        setCorelationId("")
      } else if (isCalling) {
        // setTimeout(() => checkCallEnd(correlationId), 1000);
      }
    } catch (error) {
      console.error("Error fetching call status:", error);
      // if (isCalling) { // Check if isCalling is true in case of error
      //   setTimeout(() => checkCallEnd(correlationId), 5000); // Retry after 5 seconds
      // }
    }
  };

  // useEffect(() => {
  //   if (isCalling) {
  //     setTimeout(() => checkCallEnd(corelationId), 1000);
  //   }
  // });

  const handleCallClick = async () => {
    setCallLoading(true);
    try {
      let apiUrl = `${webApi}`;
      if (selectedServiceDivisionCall) {
        apiUrl += `/call/teachers_calling/?teacher_id=${newAdmin.teacher_id}&service_devision_id=${selectedServiceDivisionCall}`;
      }
      if (work_assign_id !== null) {
        apiUrl += `/call/teachers_task_calling/?teacher_id=${newAdmin.teacher_id}&emp_work_assignment_status_id=${work_assign_id}`;
      }
      const response = await fetch(
        apiUrl,
        options
      );

      const responseData = await response.json();

      if (!response.ok) {
        const errorMessage =
          responseData.detail || responseData.error || "An error occurred";
        setToastMessage(errorMessage);
        setShowSolidDangerToast(true);
        setTimeout(() => setShowSolidDangerToast(false), 3000);
        console.error(errorMessage);
        return; // Exit early if the first call fails
      }

      // First call succeeded
      setIsCalling(true);
      setCallDuration(0);
      setCorelationId(responseData.correlationId);

      if (intervalId) {
        clearInterval(intervalId);
      }

      const id = setInterval(() => {
        setCallDuration((prev) => prev + 1);
      }, 1000);
      setIntervalId(id);

      checkCallEnd(responseData.correlationId);
      setSelectedServiceDivisionCall("")
      // Make the second API call
      const statusResponse = await fetch(
        `${webApi}/user_monitoring/change_agent_status/3/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({}),
        }
      );

      if (!statusResponse.ok) {
        const statusError = await statusResponse.json();
        console.error("Error updating agent status:", statusError);
      }
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Unknown error occurred while calling API";
      setToastMessage(`Error: ${errorMessage}`);
      setShowSolidDangerToast(true);
      setTimeout(() => setShowSolidDangerToast(false), 3000);
      console.error("API call error:", error);
    } finally {
      setCallLoading(false);
    }
  };

  // const handleMessageClick = async () => {
  //   setMessageLoading(true);
  //   try {
  //     const response = await fetch(
  //       `${webApi}/sms/send_wizklub_sms/?scsnumber=${newAdmin.SCS_Number}`,
  //       options
  //     );

  //     const responseData = await response.json();

  //     if (!response.ok) {
  //       const errorMessage =
  //         responseData.detail || responseData.error || "An error occurred";
  //       setToastMessage(errorMessage);
  //       setShowSolidDangerToast(true);
  //       setTimeout(() => setShowSolidDangerToast(false), 3000);
  //       console.error(errorMessage);
  //       return; // Exit early if the first call fails
  //     }
  //     setToastMessage(responseData.message);
  //     setshowSolidSuccessToast(true);
  //     setTimeout(() => setshowSolidSuccessToast(false), 3000);
  //   } finally {
  //     setMessageLoading(false);
  //   }
  // };

  // const handleWhasappClick = async () => {
  //   setWhatsappLoading(true);
  //   try {
  //     const response = await fetch(
  //       `${webApi}/whatsapp/send_wizklub_whatsapp_message/?scsnumber=${newAdmin.SCS_Number}`,
  //       options
  //     );

  //     const responseData = await response.json();

  //     if (!response.ok) {
  //       const errorMessage =
  //         responseData.detail || responseData.error || "An error occurred";
  //       setToastMessage(errorMessage);
  //       setShowSolidDangerToast(true);
  //       setTimeout(() => setShowSolidDangerToast(false), 3000);
  //       console.error(errorMessage);
  //       return; // Exit early if the first call fails
  //     }
  //     setToastMessage(responseData.message);
  //     setshowSolidSuccessToast(true);
  //     setTimeout(() => setshowSolidSuccessToast(false), 3000);
  //   } finally {
  //     setWhatsappLoading(false);
  //   }
  // };

  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);

  const handleEndCallClick = async () => {
    setIsCalling(false);
    // Handle call end logic
    await fetch(`${webApi}/user_monitoring/change_agent_status/1/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({}), // Empty JSON object (not a string)
    });
    setCorelationId("");
  };

  const formatLocalDateTimeString = (localDateTime: string): string => {
    // Input: "2025-03-06 07:14:00"
    const [datePart, timePart] = localDateTime.split(" ");
    const [year, month, day] = datePart.split("-");
    const [hours, minutes] = timePart.split(":");

    // Output: "2025-03-06T07:14"
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [selectedBranch, setSelectedBranch] = useState<number>(() => {
    return Number(localStorage.getItem("scoreBranchIdForEmployee")) || 0;
  });

  const [selectedScoreDate, setSelectedScoreDate] = useState<string>(() => {
    return String(localStorage.getItem("ScoreBranchDateForEmployee")) || "";
  });

  const fetchSlotsData = async () => {
    try {
      setSlotsLoading(true);

      const response = await fetch(
        `${webApi}/infinityteacherslogindata/get_infinity_teacher_login_data_card/${id}/`,
        options
      );
      const result = await response.json();

      // result.data is a single object
      const extractedSlots: Slot[] = [result.data];

      setSlots(extractedSlots);
    } catch (error) {
      console.error("Error fetching slots:", error);
    } finally {
      setSlotsLoading(false);
    }
  };



  const fetchData = async () => {
    setIsLoading(true);
    try {
      if (id) {
        const [
          providerData,
          // ticketDataResponse,
          // priorityDataResponse,
          // categoryResponse,
          callDataResponse,
        ] = await Promise.all([
          fetchProviderData(id),
          // fetchTicketData(id,selectedServiceDivision),
          // fetchPriorityData(),
          // fetchCategoriesData(),
          fetchCallLog(id),
        ]);

        setData(providerData);
        setData(providerData);
        setNewAdmin(providerData);
        setSibiling(providerData.siblings);
        // setTicketData(ticketDataResponse);
        setCallLogs(callDataResponse.results);
        await fetchOrientationsDropdown(providerData.branch);
        // setDispositionData(dispositionDataResponse);
        // setPriorityData(priorityDataResponse);
        // setTypeOfTicketData(typeOfTicketDataResponse);
        // setCategoriesData(categoryResponse);
        // const student_ticket_id = ticketDataResponse.ticket_id;
        // setTicketId(student_ticket_id);
        // const ticketLogsData = await fetchTicketLogs(Number(id));
        // setTicketLogs(ticketLogsData.results);
        // setNewTicket(ticketDataResponse);
        // const selectedCategory = categoryResponse.find(
        //   (c: { category_id: any }) =>
        //     c.category_id === ticketDataResponse.category
        // );
        // setSelectedCategory(
        //   selectedCategory
        //     ? {
        //       value: selectedCategory.category_id.toString(),
        //       label: selectedCategory.category_name,
        //     }
        //     : null
        // );

        // if (selectedCategory) {
        //   const subCategoryDataResponse = await fetchSubCategoryData(
        //     selectedCategory.category_id
        //   );
        //   const subCategories = subCategoryDataResponse.map(
        //     (sc: {
        //       subcategory_id: { toString: () => any };
        //       subcategory_name: any;
        //     }) => ({
        //       value: sc.subcategory_id.toString(),
        //       label: sc.subcategory_name,
        //     })
        //   );

        //   const selectedSubCategory = subCategoryDataResponse.find(
        //     (sc: { subcategory_id: any }) =>
        //       sc.subcategory_id === ticketDataResponse.subcategory
        //   );
        //   setSelectedSubCategory(
        //     selectedSubCategory
        //       ? {
        //         value: selectedSubCategory.subcategory_id.toString(),
        //         label: selectedSubCategory.subcategory_name,
        //       }
        //       : null
        //   );
        // }

        // const selectedPriority = priorityDataResponse.find(
        //   (p: { priority_id: any }) =>
        //     p.priority_id === ticketDataResponse.priority
        // );
        // setSelectedPriority(
        //   selectedPriority
        //     ? {
        //       value: selectedPriority.priority_id.toString(),
        //       label: selectedPriority.priority_name,
        //     }
        //     : null
        // );

        // const apiCallBackTime = ticketDataResponse.call_back_time_local
        //   ? formatLocalDateTimeString(ticketDataResponse.call_back_time_local)
        //   : null;


        // setNewTicket((prevTicket) => ({
        //   ...prevTicket,
        //   call_back_time: apiCallBackTime,
        // }));

      } else {
        console.error("ID is undefined");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (newTicket.category) {
      // Find the selected category in your categories data
      const selectedCategory = categoriesData.find(
        (category: { category_id: number }) =>
          category.category_id === newTicket.category
      );

      // Set showCallBackTime based on the is_callback_time property
      setShowCallBackTime(selectedCategory?.is_callback_time || false);
    } else {
      setShowCallBackTime(false);
    }
  }, [newTicket, categoriesData]); // Add categoriesData to dependencies

  const fetchData1 = async (id: number) => {
    try {
      const response = await fetch(
        `${webApi}/scripting/manage_scripts/${id}/`,
        options
      );
      const result = await response.json();
      if (result.data && result.data.script_file) {
        setPdfSrc(result.data.script_file);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // const fetchDropdownData = async () => {
  //   try {
  //     const response = await fetch(
  //       `${webApi}/scripting/wizklub_script_dropdown/`,
  //       options
  //     );
  //     const result = await response.json();
  //     if (Array.isArray(result)) {
  //       setScriptDropdown(result);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching dropdown data:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchDropdownData();
  // }, []);

  const handleSelectChange = (event: { target: { value: any } }) => {
    const scriptId = event.target.value;
    setSelectedScript(scriptId);
    fetchData1(scriptId);
  };

  const toggleCard = () => {
    setShowCard(!showCard);
    setShowForm(false);
    setShowCallLogs(false);
    setShowTicketLogs(false);
  };

  const updateData = async () => {
    const requestOptions = {
      method: newTicket.new_ticket === "True" ? "POST" : "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newTicket),
    };
    const url = `${webApi}/employees/teacher_ticket_operations/${id}/${selectedServiceDivision}/`;
    try {
      const response = await fetch(url, requestOptions);
      if (!response.ok) {
        const errorData = await response.json();
        setToastMessage(errorData.message);
        setShowSolidDangerToast(true);
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setToastMessage("Ticket updated successfully");
      setshowSolidSuccessToast(true);

      setTimeout(() => {
        setshowSolidSuccessToast(false);
      }, 3000);
      return response;
    } catch (error) {
      console.error("An error occurred:", error);
      setToastMessage("An error occurred while updating data.");
      return null; // ✅ Return null in case of an error
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowSolidDangerToast(false);
    }, 3000);
  }, [toastMessage]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!selectedCategory) {
      setToastMessage("please Select a Category");
      setShowSolidDangerToast(true);
      setTimeout(() => {
        setShowSolidDangerToast(false);
      }, 3000);
      return;
    } else if (!selectedSubCategory) {
      setToastMessage("please Select a Sub Category");
      setShowSolidDangerToast(true);
      setTimeout(() => {
        setShowSolidDangerToast(false);
      }, 3000);
      return;
    }
    setIsLoading1(true);
    try {
      const response = await updateData();
      if (!response || !response.ok) {
        // ✅ Stop execution if update failed
        console.error("Update failed, stopping further execution.");
        return;
      }


      fetchTicketLogs(Number(id));
      setShowForm(false);
      setShowTicketLogs(true);
      setSelectedServiceDivision(null);


      // if (typeof ticket_id !== "undefined") {
      // handleToggleTicketLogs(ticket_id);
      // }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading1(false);
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    if (name === "call_back_time") {
      const formattedValue = value
        ? dayjs(value).format("YYYY-MM-DD HH:mm:ss")
        : undefined;
      setNewTicket({ ...newTicket, [name]: formattedValue });
      // e.target.blur();
    } else {
      setNewTicket({ ...newTicket, [name]: value || undefined });
    }
  };

  const categoryOptions = categoriesData.map((c) => ({
    value: c.category_id.toString(),
    label: c.category_name,
  }));

  const serviceDivisionOptions = serviceDivisions.map((c) => ({
    value: c.id.toString(),
    label: c.name,
  }));

  const subCategoryOptions = subCategoryData.map((sc) => ({
    value: sc.subcategory_id.toString(),
    label: sc.subcategory_name,
  }));

  const priorityOptions = priorityData.map((p) => ({
    value: p.priority_id.toString(),
    label: p.priority_name,
  }));

  const handleCategoryChange = async (selected: Option | null) => {
    const category = categoriesData.find(
      (c) => c.category_id === parseInt(selected?.value || "")
    );
    setSelectedCategory(
      category
        ? {
          value: category.category_id.toString(),
          label: category.category_name,
        }
        : null
    );
    setSelectedSubCategory(null);
    setNewTicket({
      ...newTicket,
      category: category?.category_id,
      subcategory: null,
    });

    if (category && [2, 3].includes(category.category_id)) {
      setShowCallBackTime(true);
    } else {
      setShowCallBackTime(false);
    }

    if (category) {
      const subCategoryDataResponse = await fetchSubCategoryData(
        category.category_id
      );
      setSubCategoryData(subCategoryDataResponse);
    }
  };

  const handleSubCategoryChange = (selected: Option | null) => {
    const subCategory = subCategoryData.find(
      (sc) => sc.subcategory_id === parseInt(selected?.value || "")
    );
    setSelectedSubCategory(
      subCategory
        ? {
          value: subCategory.subcategory_id.toString(),
          label: subCategory.subcategory_name,
        }
        : null
    );
    setNewTicket({
      ...newTicket,
      subcategory: subCategory?.subcategory_id,
    });
  };

  const handlePriorityChange = (selected: Option | null) => {
    const priority = priorityData.find(
      (p) => p.priority_id === parseInt(selected?.value || "")
    );
    setSelectedPriority(
      priority
        ? {
          value: priority.priority_id.toString(),
          label: priority.priority_name,
        }
        : null
    );
    setNewTicket({
      ...newTicket,
      priority: priority?.priority_id,
    });
  };

  useEffect(() => {
    if (newTicket.category) {
      fetchSubCategoryData(newTicket.category).then(
        (subCategoryDataResponse) => {
          setSubCategoryData(subCategoryDataResponse);
        }
      );
    }
  }, [newTicket.category]);

  useEffect(() => {
    const fetchPdf = async () => {
      const options = {
        method: "GET",
        // mode: "no-cors" as RequestMode, // Cast to RequestMode
        headers: {
          // "Content-Type": "application/pdf",
          Authorization: `Bearer ${jwtToken}`,
          // "Cache-Control": "no-cache",
        },
      };

      try {
        const response = await fetch(pdfSrc, options);
        if (response.ok) {
          const blob = await response.blob();
          const url = URL.createObjectURL(blob);
          setPdfUrl(url);
        } else {
          console.error("Failed to fetch PDF");
        }
      } catch (error) {
        console.error("Error fetching PDF:", error);
      }
    };

    fetchPdf();
  }, [pdfSrc, jwtToken]);

  useEffect(() => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);

  const ringingAnimation = `
@keyframes ringing {
  0% { transform: translateY(0); }
  25% { transform: translateY(-2px); }
  50% { transform: translateY(2px); }
  75% { transform: translateY(-2px); }
  100% { transform: translateY(0); }
}
`;

  const styleSheet = document.styleSheets[0];
  styleSheet.insertRule(ringingAnimation, styleSheet.cssRules.length);

  const iconStyles = {
    chatScript: {
      fontSize: "24px",
      color: "blue",
      cursor: "pointer",
      marginBottom: "10px",
    },
    leaderboard: {
      fontSize: "24px",
      color: "green",
      cursor: "pointer",
      marginBottom: "10px",
    },
    chat: {
      fontSize: "24px",
      color: "red",
      cursor: "pointer",
      marginBottom: "10px",
    },
  };

  const containerStyle = {
    position: "fixed" as "fixed",
    bottom: "10px",
    right: "10px",
    display: "flex",
    flexDirection: "column" as "column",
    gap: "10px",
    backgroundColor: "rgba(255, 255, 255, 0.8)", // Optional: Add background for better visibility
    borderRadius: "8px", // Optional: Rounded corners
    padding: "10px", // Optional: Add some padding
  };

  // useEffect(() => {
  //   console.log(newAdmin);
  // });

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Employee Ticket</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.wizklubDashboard}>Dashboard</Link>
                  </li>
                  {/* <li className="breadcrumb-item">
                    <Link to={routes.employeeBranches}>Branches</Link>
                  </li> */}

                  <>
                    {r1 === 1 && (
                      <li className="breadcrumb-item">
                        <Link to={routes.employeeDetails}>Employee</Link>
                      </li>
                    )}

                    {r1 === 2 && (
                      <li className="breadcrumb-item">
                        <Link to={routes.employeeDailed}>Dailed Employee</Link>
                      </li>
                    )}

                    {r1 === 3 && (
                      <>
                        <li className="breadcrumb-item">
                          <Link to={routes.scoreEmployeeBranches}>Branches</Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to={routes.scoreEmployeeDetails}>Employee</Link>
                        </li>
                      </>
                    )}

                    {r1 === 4 && (
                      <>
                        <li className="breadcrumb-item">
                          <Link to={routes.scoreDailedEmployeeBranches}>Branches</Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to={routes.scoreDailedEmployeeDetails}>Dailed Employee</Link>
                        </li>
                      </>
                    )}
                    {r1 === 5 && (
                      <li className="breadcrumb-item">
                        <Link to={routes.pendingEmployeeDetails}>Pending Employee</Link>
                      </li>
                    )}
                    {r1 === 6 && (
                      <li className="breadcrumb-item">
                        <Link to={routes.completedEmployeeDetails}>Completed Employee</Link>
                      </li>
                    )}
                  </>
                  <li className="breadcrumb-item active">Ticket</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Non-editable Fields Card */}
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                height: "100vh",
                paddingTop: "20px",
              }}
            >
              <Spin /> {/* Display loader while loading */}
            </div>
          ) : (
            <div>
              <div
                className="card"
                style={{
                  width: "25%",
                  margin: "5px",
                  float: "left",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  borderRadius: "12px",
                  // background: "linear-gradient(135deg, #e0f7fa, #f3e5f5)",
                  border: "1px solid #d1d5db",
                }}
              >
                <div className="card-body">
                  {/* <img
                    src="https://cdn-icons-png.flaticon.com/128/4466/4466375.png"
                    alt="Higher Education Illustration"
                    style={{
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                      width: "80%",
                      borderRadius: "12px",
                    }}
                  /> */}
                  {/* <h5
                    className="card-title"
                    style={{ fontWeight: "bold", marginBottom: "15px" }}
                  >
                    Student Details
                  </h5> */}
                  {/* Details Rows */}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>Employee Code:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{newAdmin.employee_code}</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>Full Name:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{newAdmin.full_name}</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>Gender:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{newAdmin.gender_name}</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>Branch:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{newAdmin.branch_name}</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>Department:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{newAdmin.department_name}</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>Designation:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{newAdmin.designation_name}</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>Orientation:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{newAdmin.orientation_name}</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>class_teacher_of_class:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{newAdmin.class_teacher_class_name}</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>class_teacher_of_section:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{newAdmin.class_teacher_section_name}</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>Qualification:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{newAdmin.qualification}</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>Years of Experience:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>
                      {newAdmin.years_of_experience ?? "N/A"}
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>Date of Joining:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{newAdmin.date_of_joining}</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>Email:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>
                      {newAdmin.email ?? "N/A"}
                    </span>
                  </div>
                  {checkPermission(
                    "can_view_employee_mobile_number",
                    "teacher"
                  ) && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px 0",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        <span style={{ fontWeight: "bold", color: "#4b5563" }}>Phone Number:</span>
                        <span style={{ textAlign: "right", color: "#1f2937" }}>
                          {newAdmin.phone_number ?? "N/A"}
                        </span>
                      </div>
                    )}

                  {/* <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>Is Active:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>
                      {newAdmin.is_active ? "Yes" : "No"}
                    </span>
                  </div> */}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>No. of Attempts:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{newAdmin.no_of_attempts}</span>
                  </div>
                  {checkPermission(
                    "can_view_employee_mobile_number",
                    "teacher"
                  ) && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px 0",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        <span style={{ fontWeight: "bold", color: "#4b5563" }}>
                          Phone Number:
                        </span>
                        <span
                          style={{
                            textAlign: "right",
                            color: "#1f2937",
                            cursor: "pointer",
                          }}
                          onClick={toggleLock}
                        >
                          {isLocked ? (
                            <span role="img" aria-label="locked">
                              &#128274; {/* Closed lock icon */}
                            </span>
                          ) : (
                            phoneNumber || (
                              <span role="img" aria-label="unlocked">
                                &#128275; {/* Open lock icon */}
                              </span>
                            )
                          )}
                        </span>
                      </div>
                    )}
                  {checkPermission(
                    "change_teacher",
                    "teacher"
                  ) && (
                      <div style={{ marginTop: "10px" }}>
                        <a href="#" onClick={handleEditClick} style={{ color: "#2563eb", textDecoration: "underline" }}>
                          Edit Form card
                        </a>
                      </div>
                    )}
                  {showModal && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                        padding: "20px", // For small screen spacing
                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#fff",
                          padding: "20px",
                          borderRadius: "12px",
                          width: "100%",
                          maxWidth: "500px",
                          boxShadow: "0 8px 16px rgba(0, 0, 0, 0.25)",
                          display: "flex",
                          flexDirection: "column",
                          gap: "14px",
                          boxSizing: "border-box",
                        }}
                      >
                        <h2 style={{ textAlign: "center", marginBottom: "10px" }}>
                          Edit Teacher Info
                        </h2>

                        <label htmlFor="class">Class:</label>
                        <select
                          id="class"
                          value={selectedClass ?? ""}
                          onChange={(e) => setSelectedClass(Number(e.target.value))}
                          style={{
                            padding: "10px",
                            borderRadius: "8px",
                            border: "1px solid #ccc",
                            outline: "none",
                            fontSize: "16px",
                          }}
                        >
                          <option value="" disabled>
                            Select Class
                          </option>
                          {classOptions.map((opt) => (
                            <option key={opt.class_name_id} value={opt.class_name_id}>
                              {opt.label}
                            </option>
                          ))}
                        </select>

                        <label htmlFor="branch">Orientation:</label>
                        <select
                          id="branch"
                          value={selectedOrientation ?? ""}
                          onChange={(e) => setSelectedOrientation(Number(e.target.value))}
                          style={{
                            padding: "10px",
                            borderRadius: "8px",
                            border: "1px solid #ccc",
                            outline: "none",
                            fontSize: "16px",
                          }}
                        >
                          <option value="" disabled>
                            Select Orientation
                          </option>
                          {branchOptions.map((opt) => (
                            <option key={opt.orientation_id} value={opt.orientation_id}>
                              {opt.label}
                            </option>
                          ))}
                        </select>

                        <label htmlFor="section">Section:</label>
                        <select
                          id="section"
                          value={selectedSection ?? ""}
                          onChange={(e) => setSelectedSection(Number(e.target.value))}
                          style={{
                            padding: "10px",
                            borderRadius: "8px",
                            border: "1px solid #ccc",
                            outline: "none",
                            fontSize: "16px",
                          }}
                        >
                          <option value="" disabled>
                            Select Section
                          </option>
                          {sectionOptions.map((opt) => (
                            <option key={opt.section_id} value={opt.section_id}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                        <label htmlFor="phoneNumber">Phone Number:</label>
                        <input
                          type="tel"
                          id="phoneNumber"
                          value={manualPhoneNumber}
                          onChange={(e) => setManualPhoneNumber(e.target.value)}
                          style={{
                            padding: "10px",
                            borderRadius: "8px",
                            border: "1px solid #ccc",
                            outline: "none",
                            fontSize: "16px",
                            width: "100%", // Optional: makes the input stretch full width
                          }}
                          placeholder="Enter phone number"
                        />

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "20px",
                          }}
                        >
                          <button
                            onClick={() => setShowModal(false)}
                            style={{
                              backgroundColor: "#ef4444",
                              color: "#fff",
                              padding: "10px 20px",
                              borderRadius: "6px",
                              border: "none",
                              cursor: "pointer",
                              fontSize: "16px",
                              flex: 1,
                              marginRight: "10px",
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handleSave}
                            style={{
                              backgroundColor: "#2563eb",
                              color: "#fff",
                              padding: "10px 20px",
                              borderRadius: "6px",
                              border: "none",
                              cursor: "pointer",
                              fontSize: "16px",
                              flex: 1,

                            }}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#4b5563" }}>Button:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{newAdmin.button}</span>
                  </div> */}

                  {/* <div style={{ marginTop: "10px" }}>
                    <a href="#" onClick={() => openModal()} style={{ color: "#2563eb", textDecoration: "underline" }}>
                      Add Custom Phone Number
                    </a>
                  </div>
                  {contacts.map((contact) => (
                    <div
                      key={contact.id}
                      style={{ padding: "8px 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}
                    >
                      <div>
                        <strong>{contact.relation_type_name}</strong>: {contact.name} ({contact.phone_number})
                      </div>
                      <button className="btn btn-sm btn-outline-primary" onClick={() => openModal(contact)}>
                        Edit
                      </button>
                    </div>
                  ))} */}
                  {selectedServiceDivision === "4" && (
                    <>
                      <h5
                        style={{
                          marginTop: "15px",
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                      >
                        Login Data
                      </h5>

                      {slotsloading ? (
                        <div
                          style={{
                            margin: "10px",
                            padding: "15px",
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                            backgroundColor: "#ffffff",
                            textAlign: "center",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "14px",
                              color: "#6b7280",
                              display: "inline-block",
                            }}
                          >
                            🔄 Loading Data...
                          </span>
                        </div>
                      ) : (
                        slots &&
                        slots.length > 0 && (
                          <div
                            style={{
                              margin: "10px",
                              padding: "15px",
                              border: "1px solid #e5e7eb",
                              borderRadius: "8px",
                              backgroundColor: "#ffffff",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            {/* Refresh button */}
                            {/* <div
                              style={{
                                textAlign: "right",
                                marginBottom: "10px",
                              }}
                            >
                              <button
                                onClick={fetchSlotsData}
                                disabled={slotsloading}
                                style={{
                                  backgroundColor: slotsloading ? "#93c5fd" : "#2563eb",
                                  color: "#fff",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  border: "none",
                                  cursor: slotsloading ? "not-allowed" : "pointer",
                                  fontSize: "14px",
                                  width: "100%",
                                  maxWidth: "120px",
                                }}
                              >
                                {slotsloading ? "Refreshing..." : "Refresh"}
                              </button>
                            </div> */}

                            {/* Responsive table */}
                            <div style={{ overflowX: "auto" }}>
                              <table
                                style={{
                                  width: "100%",
                                  minWidth: "500px",
                                  borderCollapse: "collapse",
                                  textAlign: "center",
                                }}
                              >
                                <thead>
                                  <tr style={{ backgroundColor: "#f9fafb" }}>
                                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>
                                      LAST_LOGGED_DATE
                                    </th>
                                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>
                                      NO_OF_LOGINS
                                    </th>
                                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>
                                      NO_OF_HOMEWORK_GIVEN
                                    </th>
                                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>
                                      NO_OF_STUDENTS_TO_HOMEWORKS
                                    </th>
                                    <th style={{ padding: "8px", border: "1px solid #e5e7eb" }}>
                                      NO_OF_STUDENT_SUBMITTED
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {slots.map((slot, index) => (
                                    <tr key={index}>
                                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>
                                        {slot.last_logged_date}
                                      </td>
                                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>
                                        {slot.no_of_logins}
                                      </td>
                                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>
                                        {slot.no_of_homework_given}
                                      </td>
                                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>
                                        {slot.no_of_students_to_homeworks}
                                      </td>
                                      <td style={{ padding: "8px", border: "1px solid #e5e7eb" }}>
                                        {slot.no_of_student_submitted}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )
                      )}
                    </>
                  )}
                </div>
              </div>

              {/* Update Ticket and Ticket Logs Buttons */}
              <div
                className="row justify-content-center"
                style={{
                  marginTop: "20px",
                  marginBottom: "15px",
                  marginLeft: "5px",
                }}
              >
                <div className="col-sm-12 d-flex justify-content-between">
                  <div>
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleToggleForm}
                    >
                      Ticket
                    </button>
                    {/* <button
                      className="btn btn-primary me-2"
                      onClick={handleToggleCallHistory}
                    >
                      Call History
                    </button> */}

                    {checkPermission(
                      "view_teacherticketlog",
                      "teacherticketlog"
                    ) && (
                        <button
                          className="btn btn-primary me-2"
                          onClick={() => id && handleToggleTicketLogs(Number(id))}
                        >
                          {ticketLogLoading ? (
                            <i className="spinner-border spinner-border-sm"></i>
                          ) : (
                            <>TicketLog</>
                          )}
                        </button>
                      )}

                    {checkPermission("can_view_employee_wise_call_log", "calllog") && (
                      <button
                        className="btn btn-primary"
                        onClick={handleToggleCallLogs}
                      >
                        {callLogLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Call Log</>
                        )}
                      </button>
                    )}
                  </div>
                  <div>
                    {checkPermission("can_call", "Call") && (
                      <button
                        className="btn btn-success me-2"
                        style={{ backgroundColor: "#28a745", color: "white" }}
                        // onClick={() => {
                        //   if (
                        //     window.confirm(
                        //       "Are you sure want to make this call?"
                        //     )
                        //   ) {
                        //     handleCallClick();
                        //   }
                        // }}
                        // onClick={handleCallButtonClick}
                        data-bs-toggle="modal"
                        data-bs-target="#call_confirmation_modal"
                        disabled={isLoading || isCalling}
                      >
                        {callLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>
                            <i className="ti ti-phone"></i> Call
                          </>
                        )}
                      </button>
                    )}

                    {/* {checkPermission("can_whatapp", "WhatsApp") && (
                      <button
                        className="btn btn-success me-2"
                        style={{ backgroundColor: "#25D366", color: "white" }}
                        data-bs-toggle="modal"
                        data-bs-target="#whatsapp_confirmation_modal"
                        disabled={whatsappLoading}
                      >
                        {messageLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>
                            <i className="ti ti-brand-whatsapp"></i> WhatsApp
                          </>
                        )}
                      </button>
                    )}
                    {checkPermission("can_message", "Message") && (
                      <button
                        className="btn btn-success"
                        style={{ backgroundColor: "#007bff", color: "white" }}
                        data-bs-toggle="modal"
                        data-bs-target="#message_confirmation_modal"
                        disabled={messageLoading}
                      >
                        {messageLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>
                            <i className="ti ti-message"></i> TextMessage
                          </>
                        )}
                      </button>
                    )} */}
                  </div>
                </div>
              </div>

              {/* Editable Form */}
              {showForm && (
                <div className="row justify-content-center">
                  <div className="col-sm-12 d-flex justify-content-center">
                    <div
                      className="card"
                      style={{
                        width: "100%",
                        // background: "linear-gradient(135deg, #e0f7fa, #f3e5f5)",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                        borderRadius: "12px",
                        padding: "20px",
                        backgroundColor: "#fff",
                        border: "1px solid #d1d5db",
                      }}
                    >
                      <div className="card-body">
                        <form onSubmit={handleSubmit}>
                          <div
                            className="modal-body light-violet-bg d-flex"
                            style={{ flexWrap: "wrap" }}
                          >
                            {/* Form Fields */}
                            {/* <div
                            className="mb-3 me-3"
                            style={{
                              flex: "1 1 100%",
                              maxWidth: "300px",
                              marginRight: "15px",
                              width: "300px",
                            }}
                          >
                            <label className="form-label">Disposition</label>
                            <CommonSelect
                              className="select"
                              options={dispositionOptions}
                              onChange={handleDispositionChange}
                              defaultValue={dispositionOptions.find(
                                (option) =>
                                  option.value ===
                                  newTicket.disposition?.toString()
                              )}
                            />
                          </div> */}
                            <div
                              className="mb-3 me-3"
                              style={{
                                flex: "1 1 100%",
                                maxWidth: "300px",
                                marginRight: "15px",
                                width: "300px",
                              }}
                            >
                              <label className="form-label">Service Division</label>
                              <CommonSelect
                                className="select"
                                options={serviceDivisionOptions}
                                onChange={(selectedOption) => {
                                  if (!selectedOption) return; // Handle null case
                                  const serviceDivision = selectedOption.value;
                                  if (serviceDivision && id) { // Ensure both values exist
                                    // fetchCategoriesData(serviceDivision);
                                    fetchTicketData(id, serviceDivision);
                                    setSelectedServiceDivision(serviceDivision);
                                  }
                                }}
                                value={selectedServiceDivision ? {
                                  value: selectedServiceDivision,
                                  label: serviceDivisions.find(s => s.id.toString() === selectedServiceDivision)?.name || ""
                                } : null}
                                isRequired
                              />
                            </div>
                            {serviceDivisionLoading ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "flex-start",
                                  height: "100vh",
                                  paddingTop: "20px",
                                }}
                              >
                                <Spin /> {/* Display loader while loading */}
                              </div>
                            ) : (
                              selectedServiceDivision && (
                                <>
                                  <div
                                    className="mb-3 me-3"
                                    style={{
                                      flex: "1 1 100%",
                                      maxWidth: "300px",
                                      marginRight: "15px",
                                      width: "300px",
                                    }}
                                  >
                                    <label className="form-label">Category</label>
                                    <CommonSelect
                                      className="select"
                                      options={categoryOptions}
                                      onChange={handleCategoryChange}
                                      value={selectedCategory}
                                      isRequired
                                    />
                                  </div>

                                  {showCallBackTime && (
                                    <div
                                      className="form-group mb-3"
                                      style={{
                                        width: "300px",
                                        maxWidth: "300px",
                                        marginRight: "15px",
                                        position: "relative",
                                      }}
                                    >
                                      <label className="form-label">Call Back Time</label>
                                      <input
                                        type="datetime-local"
                                        className="form-control"
                                        name="call_back_time"
                                        placeholder="Call Back Time"
                                        onChange={handleInputChange}
                                        value={newTicket.call_back_time || ""}
                                        required
                                        min={new Date().toISOString().slice(0, 16)}
                                        onFocus={() => {
                                          const doneText = document.getElementById("doneText");
                                          if (doneText) doneText.style.display = "inline";
                                        }}
                                        onBlur={() => {
                                          const doneText = document.getElementById("doneText");
                                          if (doneText) doneText.style.display = "none";
                                        }}
                                      />
                                      <small
                                        id="doneText"
                                        className="text-primary"
                                        style={{
                                          cursor: "pointer",
                                          position: "absolute",
                                          right: "10px",
                                          top: "5px",
                                          display: "none",
                                        }}
                                        onClick={() => {
                                          const inputElement = document.querySelector<HTMLInputElement>(
                                            'input[name="call_back_time"]'
                                          );
                                          if (inputElement) inputElement.blur();
                                        }}
                                      >
                                        Done
                                      </small>
                                    </div>
                                  )}

                                  <div
                                    className="mb-3"
                                    style={{
                                      flex: "1 1 100%",
                                      maxWidth: "300px",
                                      marginRight: "15px",
                                      width: "300px",
                                    }}
                                  >
                                    <label className="form-label">Sub-Category</label>
                                    <CommonSelect
                                      className="select"
                                      options={subCategoryOptions}
                                      onChange={handleSubCategoryChange}
                                      value={selectedSubCategory}
                                    />
                                  </div>

                                  <div
                                    className="mb-3 me-3"
                                    style={{
                                      flex: "1 1 100%",
                                      maxWidth: "300px",
                                      marginRight: "15px",
                                      width: "300px",
                                    }}
                                  >
                                    <label className="form-label">Priority</label>
                                    <CommonSelect
                                      className="select"
                                      options={priorityOptions}
                                      onChange={handlePriorityChange}
                                      value={selectedPriority}
                                    />
                                  </div>

                                  <div
                                    className="form-group mb-3"
                                    style={{ flex: "1 1 100%", minWidth: "200px" }}
                                  >
                                    <label className="form-label">Description</label>
                                    <textarea
                                      className="form-control"
                                      name="description"
                                      placeholder="Description"
                                      onChange={handleInputChange}
                                      value={newTicket.description || ""}
                                      rows={4}
                                    />
                                  </div>
                                </>
                              )
                            )}
                          </div>
                          {selectedServiceDivision && (
                            <div className="modal-footer">
                              <Link
                                className="btn btn-primary"
                                to={routes.employeeDetails}
                                style={{
                                  backgroundColor: "lightcoral",
                                  color: "white",
                                  marginRight: "5px",
                                }}
                              >
                                Cancel
                              </Link>
                              <OverlayTrigger
                                show={showPopover}
                                placement="top"
                                overlay={popoverWarning}
                                trigger="click"
                              >
                                <button
                                  className="btn btn-primary"
                                  type={isCalling ? "button" : "submit"} // Dynamically change button type
                                  disabled={isLoading}
                                  onClick={() => {
                                    if (isCalling) {
                                      setShowPopover(true); // Show popover when calling
                                      setTimeout(
                                        () => setShowPopover(false),
                                        3000
                                      ); // Auto-hide after 3 seconds
                                    }
                                  }}
                                >
                                  {isLoading ? (
                                    <i className="spinner-border spinner-border-sm"></i>
                                  ) : (
                                    <>Save</>
                                  )}
                                </button>
                              </OverlayTrigger>
                            </div>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Ticket Logs */}
              {showTicketLogs && (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <ul
                          className="timeline"
                          style={{
                            position: "relative",
                            paddingLeft: "0",
                            listStyle: "none",
                          }}
                        >
                          <div
                            style={{
                              content: "",
                              position: "absolute",
                              top: "0",
                              bottom: "0",
                              width: "4px",
                              background: "#e9ecef",
                              left: "50%",
                              marginLeft: "-2px",
                            }}
                          ></div>
                          {ticketLogs.map((division, divisionIndex) => (
                            <div key={divisionIndex} style={{ marginBottom: "30px" }}>
                              <h3 style={{ marginBottom: "15px", color: "#333" }}>
                                Service Division: {division.service_division}
                              </h3>
                              {division.ticket_history.length > 0 ? (
                                <ul className="timeline">
                                  {division.ticket_history.map((log: {
                                    subcategory: any;
                                    call_back_time: any;
                                    priority: any;
                                    description: any;
                                    category_name: any;
                                    heading: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; updated_by_name: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined; remarks: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; updated_at: string | number | Date; call_logs: {
                                      aws_call_recording_file: string; caller_status: string; category_name: any; subcategory: any; priority: any; call_back_time: any; destination_status: string; call_start_time_: string | number | Date; call_end_time_: string | number | Date; agent_name: string |
                                      number |
                                      boolean |
                                      React.ReactElement<
                                        any, string |
                                        React.JSXElementConstructor<any>
                                      > |
                                      Iterable<React.ReactNode> |
                                      React.ReactPortal |
                                      null |
                                      undefined; call_duration_hms: string |
                                      number |
                                      boolean |
                                      React.ReactElement<
                                        any, string |
                                        React.JSXElementConstructor<any>
                                      > |
                                      Iterable<React.ReactNode> |
                                      React.ReactPortal |
                                      null |
                                      undefined; conversation_duration_hms: string |
                                      number |
                                      boolean |
                                      React.ReactElement<
                                        any, string |
                                        React.JSXElementConstructor<any>
                                      > |
                                      Iterable<React.ReactNode> |
                                      React.ReactPortal |
                                      null |
                                      undefined;
                                    }[];
                                  }, index: number) => (
                                    <li
                                      key={`${divisionIndex}-${index}`}
                                      className={index % 2 === 0 ? "" : "timeline-inverted"}
                                      style={{
                                        position: "relative",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <div
                                        className="card timeline-card"
                                        style={{
                                          background: index % 2 === 0 ? "#add8e6" : "#e6e6fa",
                                          padding: "10px",
                                          borderRadius: "95px",
                                          cursor: "pointer",
                                          overflowX: "auto",
                                        }}
                                        onClick={() => handleToggleLog(`${divisionIndex}-${index}`)}
                                      >
                                        <div
                                          className="timeline-heading"
                                          style={{
                                            textAlign: "center",
                                            position: "relative",
                                            zIndex: "101",
                                            whiteSpace: "nowrap",
                                            overflowX: "auto",
                                          }}
                                        >
                                          <h5 className="timeline-title" style={{ margin: "0" }}>
                                            {log.heading}
                                          </h5>
                                        </div>
                                      </div>
                                      {expandedLogs[`${divisionIndex}-${index}`] && (
                                        <div
                                          className="timeline-panel"
                                          style={{
                                            position: "relative",
                                            width: "100%",
                                            float: index % 2 === 0 ? "left" : "right",
                                            padding: "20px",
                                            border: "1px solid #d4d4d4",
                                            borderRadius: "2px",
                                            background: "#fff",
                                            boxShadow: "0 1px 6px rgba(0, 0, 0, 0.175)",
                                            overflowX: "auto",
                                          }}
                                        >
                                          <div className="timeline-heading">
                                            <h4 className="timeline-title">{log.updated_by_name}</h4>
                                          </div>
                                          <div className="timeline-body">
                                            <table
                                              style={{
                                                width: "100%",
                                                tableLayout: "fixed",
                                                borderCollapse: "collapse",
                                              }}
                                            >
                                              <tbody>
                                                {log.category_name && (
                                                  <tr>
                                                    <td
                                                      style={{
                                                        fontWeight: "bold",
                                                        border: "1px solid #d4d4d4",
                                                        whiteSpace: "nowrap",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      Category:
                                                    </td>
                                                    <td
                                                      style={{
                                                        border: "1px solid #d4d4d4",
                                                        overflowX: "auto",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      {log.category_name}
                                                    </td>
                                                  </tr>
                                                )}
                                                {log.subcategory && (
                                                  <tr>
                                                    <td
                                                      style={{
                                                        fontWeight: "bold",
                                                        border: "1px solid #d4d4d4",
                                                        whiteSpace: "nowrap",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      Sub Category:
                                                    </td>
                                                    <td
                                                      style={{
                                                        border: "1px solid #d4d4d4",
                                                        overflowX: "auto",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      {log.subcategory}
                                                    </td>
                                                  </tr>
                                                )}
                                                {log.call_back_time && (
                                                  <tr>
                                                    <td
                                                      style={{
                                                        fontWeight: "bold",
                                                        border: "1px solid #d4d4d4",
                                                        whiteSpace: "nowrap",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      Call Back Time:
                                                    </td>
                                                    <td
                                                      style={{
                                                        border: "1px solid #d4d4d4",
                                                        overflowX: "auto",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      {log.call_back_time}
                                                    </td>
                                                  </tr>
                                                )}
                                                {log.priority && (
                                                  <tr>
                                                    <td
                                                      style={{
                                                        fontWeight: "bold",
                                                        border: "1px solid #d4d4d4",
                                                        whiteSpace: "nowrap",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      Priority:
                                                    </td>
                                                    <td
                                                      style={{
                                                        border: "1px solid #d4d4d4",
                                                        overflowX: "auto",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      {log.priority}
                                                    </td>
                                                  </tr>
                                                )}
                                                {log.description && (
                                                  <tr>
                                                    <td
                                                      style={{
                                                        fontWeight: "bold",
                                                        border: "1px solid #d4d4d4",
                                                        whiteSpace: "nowrap",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      Description:
                                                    </td>
                                                    <td
                                                      style={{
                                                        border: "1px solid #d4d4d4",
                                                        overflowX: "auto",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      {log.description}
                                                    </td>
                                                  </tr>
                                                )}



                                                {log.remarks && (
                                                  <tr>
                                                    <td
                                                      style={{
                                                        fontWeight: "bold",
                                                        border: "1px solid #d4d4d4",
                                                        whiteSpace: "nowrap",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      Remarks:
                                                    </td>
                                                    <td
                                                      style={{
                                                        border: "1px solid #d4d4d4",
                                                        overflowX: "auto",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      {log.remarks}
                                                    </td>
                                                  </tr>
                                                )}
                                                {log.updated_by_name && (
                                                  <tr>
                                                    <td
                                                      style={{
                                                        fontWeight: "bold",
                                                        border: "1px solid #d4d4d4",
                                                        whiteSpace: "nowrap",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      Updated By:
                                                    </td>
                                                    <td
                                                      style={{
                                                        border: "1px solid #d4d4d4",
                                                        overflowX: "auto",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      {log.updated_by_name}
                                                    </td>
                                                  </tr>
                                                )}
                                                {log.updated_at && (
                                                  <tr>
                                                    <td
                                                      style={{
                                                        fontWeight: "bold",
                                                        border: "1px solid #d4d4d4",
                                                        whiteSpace: "nowrap",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      Updated At:
                                                    </td>
                                                    <td
                                                      style={{
                                                        border: "1px solid #d4d4d4",
                                                        overflowX: "auto",
                                                        padding: "8px",
                                                      }}
                                                    >
                                                      {new Date(log.updated_at).toLocaleString()}
                                                    </td>
                                                  </tr>
                                                )}
                                                {log.call_logs &&
                                                  log.call_logs.map(
                                                    (
                                                      call: {
                                                        aws_call_recording_file: string;
                                                        caller_status: string;
                                                        destination_status: string;
                                                        call_start_time_: string | number | Date;
                                                        call_end_time_: string | number | Date;
                                                        agent_name:
                                                        | string
                                                        | number
                                                        | boolean
                                                        | React.ReactElement<
                                                          any,
                                                          | string
                                                          | React.JSXElementConstructor<any>
                                                        >
                                                        | Iterable<React.ReactNode>
                                                        | React.ReactPortal
                                                        | null
                                                        | undefined;
                                                        call_duration_hms:
                                                        | string
                                                        | number
                                                        | boolean
                                                        | React.ReactElement<
                                                          any,
                                                          | string
                                                          | React.JSXElementConstructor<any>
                                                        >
                                                        | Iterable<React.ReactNode>
                                                        | React.ReactPortal
                                                        | null
                                                        | undefined;
                                                        conversation_duration_hms:
                                                        | string
                                                        | number
                                                        | boolean
                                                        | React.ReactElement<
                                                          any,
                                                          | string
                                                          | React.JSXElementConstructor<any>
                                                        >
                                                        | Iterable<React.ReactNode>
                                                        | React.ReactPortal
                                                        | null
                                                        | undefined;
                                                      },
                                                      callIndex: React.Key | null | undefined
                                                    ) => {
                                                      // Determine if the caller and destination answered
                                                      const isCallerAnswered =
                                                        call.caller_status.toLowerCase() === "answered";
                                                      const isDestinationAnswered =
                                                        call.destination_status.toLowerCase() ===
                                                        "answered";

                                                      // Set badge color based on call status
                                                      const badgeColor =
                                                        isCallerAnswered && isDestinationAnswered
                                                          ? "success"
                                                          : "danger";

                                                      // Set icon based on whether the call was answered or not
                                                      const agentIcon = isCallerAnswered
                                                        ? "fas fa-phone text-success"
                                                        : "fas fa-phone text-danger";
                                                      const studentIcon = isDestinationAnswered
                                                        ? "fas fa-phone text-success"
                                                        : "fas fa-phone text-danger";

                                                      return (
                                                        <tr key={callIndex}>
                                                          {call.call_start_time_ && (
                                                            <td
                                                              style={{
                                                                fontWeight: "bold",
                                                                border: "1px solid #d4d4d4",
                                                                whiteSpace: "nowrap",
                                                                padding: "8px",
                                                              }}
                                                            >
                                                              Call Start:
                                                              <br />
                                                              <span
                                                                style={{
                                                                  color: "green",
                                                                  fontWeight: "bold",
                                                                }}
                                                              >
                                                                {new Date(
                                                                  call.call_start_time_
                                                                ).toLocaleString()}
                                                              </span>
                                                            </td>
                                                          )}
                                                          {call.call_end_time_ && (
                                                            <td
                                                              style={{
                                                                fontWeight: "bold",
                                                                border: "1px solid #d4d4d4",
                                                                whiteSpace: "nowrap",
                                                                padding: "8px",
                                                              }}
                                                            >
                                                              Call End:
                                                              <br />
                                                              <span
                                                                style={{
                                                                  color: "red",
                                                                  fontWeight: "bold",
                                                                }}
                                                              >
                                                                {new Date(
                                                                  call.call_end_time_
                                                                ).toLocaleString()}
                                                              </span>
                                                            </td>
                                                          )}
                                                          <td
                                                            style={{
                                                              border: "1px solid #d4d4d4",
                                                              padding: "8px",
                                                            }}
                                                          >
                                                            <div
                                                              style={{
                                                                display: "inline-block",
                                                                marginRight: "30px",
                                                                textAlign: "center",
                                                              }}
                                                            >
                                                              <h4 className="timeline-title">
                                                                {call.agent_name}{" "}
                                                                <i className={agentIcon}></i>
                                                              </h4>
                                                              {call.call_duration_hms && (
                                                                <p
                                                                  style={{
                                                                    color: "orange",
                                                                    marginBottom: "3px",
                                                                  }}
                                                                >
                                                                  {call.call_duration_hms}
                                                                </p>
                                                              )}
                                                            </div>
                                                            <div
                                                              style={{
                                                                display: "inline-block",
                                                                textAlign: "center",
                                                              }}
                                                            >
                                                              <h5 className="timeline-title">
                                                                Employee{" "}
                                                                <i className={studentIcon}></i>
                                                              </h5>
                                                              {call.conversation_duration_hms && (
                                                                <p
                                                                  style={{
                                                                    color: "orange",
                                                                  }}
                                                                >
                                                                  {call.conversation_duration_hms}
                                                                </p>
                                                              )}
                                                            </div>
                                                            {call.aws_call_recording_file && (
                                                              <div
                                                                style={{
                                                                  display: "flex",
                                                                  justifyContent: "flex-end",
                                                                  marginTop: "10px",
                                                                }}
                                                              >
                                                                <AudioPlayer
                                                                  src={call.aws_call_recording_file}
                                                                />
                                                              </div>
                                                            )}
                                                          </td>
                                                        </tr>
                                                      );
                                                    }
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <p style={{ color: "#666", fontStyle: "italic" }}>
                                  No ticket history available for this service division.
                                </p>
                              )}
                            </div>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Call Logs */}
              {showCallLogs && (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <ul className="timeline">
                          {callLogs.map((division, divisionIndex) => (
                            <div key={divisionIndex} style={{ marginBottom: "30px" }}>
                              <h3 style={{ marginBottom: "15px", color: "#333" }}>
                                Service Division: {division.service_division}
                              </h3>
                              {division.call_history.length > 0 ? (
                                <ul className="timeline">
                                  {division.call_history.map((call: { caller_status: string; destination_status: string; call_start_time_: string | number | Date; call_end_time_: string | number | Date; agent_name: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; call_duration_hms: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; conversation_duration_hms: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; employee_name: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; employee_branch: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; call_status: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; aws_call_recording_file: string; }, index: number) => {
                                    const isCallerAnswered = call.caller_status.toLowerCase() === "answered";
                                    const isDestinationAnswered = call.destination_status.toLowerCase() === "answered";
                                    const badgeColor = isCallerAnswered && isDestinationAnswered ? "success" : "danger";
                                    const agentIcon = isCallerAnswered
                                      ? "fas fa-phone text-success"
                                      : "fas fa-phone text-danger";
                                    const studentIcon = isDestinationAnswered
                                      ? "fas fa-phone text-success"
                                      : "fas fa-phone text-danger";

                                    return (
                                      <li
                                        key={`${divisionIndex}-${index}`}
                                        className={index % 2 === 0 ? "" : "timeline-inverted"}
                                      >
                                        <div className={`timeline-badge ${badgeColor}`}>
                                          <i className="fas fa-phone" />
                                        </div>
                                        <div
                                          className="timeline-panel"
                                          style={{
                                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                            borderRadius: "5px",
                                          }}
                                        >
                                          <div className="timeline-heading">
                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                              {call.call_start_time_ && (
                                                <span style={{ color: "green", fontWeight: "bold" }}>
                                                  {new Date(call.call_start_time_).toLocaleString()}
                                                </span>
                                              )}
                                              {call.call_end_time_ && (
                                                <span style={{ color: "red", fontWeight: "bold" }}>
                                                  {new Date(call.call_end_time_).toLocaleString()}
                                                </span>
                                              )}
                                            </div>
                                            <div style={{ textAlign: "center" }}>
                                              <div style={{ display: "inline-block", marginRight: "30px", textAlign: "center" }}>
                                                <h4 className="timeline-title">
                                                  {call.agent_name} <i className={agentIcon}></i>
                                                </h4>
                                                {call.call_duration_hms && (
                                                  <p style={{ color: "orange", marginBottom: "3px" }}>
                                                    {call.call_duration_hms}
                                                  </p>
                                                )}
                                              </div>
                                              <div style={{ display: "inline-block", textAlign: "center" }}>
                                                <h5 className="timeline-title">
                                                  Employee <i className={studentIcon}></i>
                                                </h5>
                                                {call.conversation_duration_hms && (
                                                  <p style={{ color: "orange" }}>
                                                    {call.conversation_duration_hms}
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                            {/* <div style={{ marginTop: "10px" }}>
                                              <p>
                                                <strong>Employee:</strong> {call.employee_name}
                                              </p>
                                              <p>
                                                <strong>Branch:</strong> {call.employee_branch}
                                              </p>
                                              <p>
                                                <strong>Status:</strong> {call.call_status}
                                              </p>
                                            </div> */}
                                          </div>
                                          <div className="timeline-body">
                                            {call.aws_call_recording_file && (
                                              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                                <AudioPlayer src={call.aws_call_recording_file} />
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </li>
                                    );
                                  })}
                                </ul>
                              ) : (
                                <p style={{ color: "#666", fontStyle: "italic" }}>
                                  No call history available for this service division.
                                </p>
                              )}
                            </div>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {isCalling && (
            <div
              style={{
                position: "fixed",
                top: "65px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "#fff",
                border: "1px solid #ddd",
                borderRadius: "5px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                padding: "10px 15px",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                fontSize: "0.9em",
                animation: "ringing 1s infinite",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "10px",
                }}
              >
                <i
                  className="ti ti-phone"
                  style={{
                    fontSize: "1.2em",
                    color: "blue",
                    marginRight: "5px",
                    animation: "ringing 1s infinite",
                  }}
                ></i>
                <span style={{ animation: "ringing 1s infinite" }}>
                  Calling to {newAdmin.full_name} - {Math.floor(callDuration / 60)}:
                  {("0" + (callDuration % 60)).slice(-2)}
                </span>
              </div>
              <button
                className="btn btn-danger btn-sm" // smaller button
                style={{
                  backgroundColor: "#dc3545",
                  color: "white",
                  padding: "5px 10px", // reduced padding
                  fontSize: "0.85em", // smaller text
                }}
                onClick={handleEndCallClick}
              >
                <i
                  className="ti ti-phone-off"
                  style={{ fontSize: "1.2em" }}
                ></i>{" "}
                End Call
              </button>
            </div>
          )}
          {showCard && (
            <div className="row justify-content-center">
              <div className="col-md-12 d-flex justify-content-center">
                <div
                  className="card"
                  style={{
                    width: "100%",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    borderRadius: "12px",
                    // padding: "20px",
                    backgroundColor: "#fff",
                    border: "1px solid #d1d5db",
                  }}
                >
                  <div className="card-body">
                    <select
                      value={selectedScript}
                      onChange={handleSelectChange}
                      style={{ marginBottom: "5px" }}
                    >
                      <option value="">Select a script</option>
                      {scriptDropdown.map((item) => (
                        <option key={item.script_id} value={item.script_id}>
                          {item.script_name}
                        </option>
                      ))}
                    </select>
                    {pdfUrl && (
                      <div>
                        <embed
                          src={pdfUrl}
                          type="application/pdf"
                          width="100%"
                          height="1100px"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          {/* /Row */}
        </div>

        {/* <div style={containerStyle}>
          {checkPermission("view_script", "script") && (
            <img
              src="https://cdn-icons-png.freepik.com/256/14955/14955846.png?ga=GA1.1.568823308.1733236272&semt=ais_hybrid"
              alt="Chat Script"
              title="Chat Script"
              style={{
                width: "50px",
                height: "50px",
                cursor: "pointer",
                marginBottom: "10px",
              }}
              onClick={toggleCard}
            />
          )}
        </div> */}
        <div
          className="modal fade"
          id="call_confirmation_modal"
          // tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Confirm Call</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                {work_assign_id == null && (
                  <div className="mb-3">
                    <label htmlFor="serviceDivision">Select Service Division</label>

                    <select
                      id="serviceDivision"
                      className="form-select"
                      value={selectedServiceDivisionCall}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                        setSelectedServiceDivisionCall(e.target.value)
                      }
                    >
                      <option value="">Select Service Division</option>

                      {serviceDivisions.map((option: { id: number; name: string }) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <p>Are you sure you want to make this call?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  style={{ marginRight: "9px" }}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                  onClick={handleCallClick}
                  disabled={work_assign_id === null && !selectedServiceDivisionCall}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="message_confirmation_modal"
          // tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Confirm Message</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to send text message?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  style={{ marginRight: "9px" }}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                // onClick={handleMessageClick}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* {showModal && (
          <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">{editingId ? "Edit Contact" : "Add Contact"}</h4>
                  <button className="btn-close" onClick={() => setShowModal(false)} />
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label>Relation Type</label>
                    <select
                      className="form-select"
                      value={formData.relation_type || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, relation_type: parseInt(e.target.value, 10) })
                      }
                    >
                      <option value="">Select Relation</option>
                      {relationTypes.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label>Name (Optional)</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.name || ""}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    />
                  </div>
                  <div className="mb-3">
                    <label>Phone Number</label>
                    <input
                      type="tel"
                      className="form-control"
                      value={formData.phone_number || ""}
                      onChange={(e) => setFormData({ ...formData, phone_number: e.target.value })}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-danger"
                    style={{ marginRight: "10px" }}
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-success" onClick={handleCustomModelSubmit}>
                    {editingId ? "Update" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )} */}
        <div
          className="modal fade"
          id="whatsapp_confirmation_modal"
          // tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Confirm Message</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to send Whatsapp message?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  style={{ marginRight: "9px" }}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                // onClick={handleWhasappClick}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  function formatKey(key: string) {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char: string) => char.toUpperCase());
  }
};

export default AddOrUpdateEmployeeTicket;
